import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import StoreHeader from './StoreHeader';
import StoreFooter from './StoreFooter';
import { CartProvider } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';

const StoreLayoutContent = () => {
  const { user } = useAuth();

  useEffect(() => {
    const loadCart = async () => {
      try {
        const { cartAPI } = await import('../../services/api');
        const res = await cartAPI.getCart();
        const { useCart } = await import('../../context/CartContext');
      } catch {}
    };
    if (user) loadCart();
  }, [user]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <StoreHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <StoreFooter />
    </div>
  );
};

const StoreLayout = () => {
  return (
    <CartProvider>
      <StoreLayoutContent />
    </CartProvider>
  );
};

export default StoreLayout;
